const SPORT_TYPE_LABELS = {
    0: "Hockey",
    1: "Soccer",
    2: "Football",
    3: "Basketball",
    4: "Cricket",
    5: "Australian Football",
    6: "Rugby",
    Hockey: "Hockey",
    Soccer: "Soccer",
    Football: "Football",
    Basketball: "Basketball",
    Cricket: "Cricket",
    AustralianFootball: "Australian Football",
    Rugby: "Rugby",
};

export function formatSportType(value) {
    if (value === undefined || value === null) return "Hockey";
    if (typeof value === "number") return SPORT_TYPE_LABELS[value] || String(value);
    if (typeof value === "string") {
        const trimmed = value.trim();
        if (trimmed === '') return 'Hockey';
        const asNum = parseInt(trimmed, 10);
        if (!isNaN(asNum) && SPORT_TYPE_LABELS[asNum]) return SPORT_TYPE_LABELS[asNum];
        const key = Object.keys(SPORT_TYPE_LABELS).find(
            (k) => String(k).toLowerCase() === trimmed.toLowerCase()
        );
        if (key) return SPORT_TYPE_LABELS[key];
        return trimmed;
    }
    return String(value);
}

export function resolveSportType(value) {
    if (value === undefined || value === null || value === "") return undefined;
    return formatSportType(value).toLowerCase().replace(/\s+/g, "_");
}
